import get from 'lodash.get';

const getRedirects = (rootState) => get(rootState, 'ws.site.meta.redirects', []);

export default getRedirects;
